import React, { useState } from 'react';
import axios from 'axios';
import { Button, Snackbar, Alert, TextField, Box, Typography, Paper } from '@mui/material';
import { v4 as uuidv4 } from 'uuid'; // For generating a unique session ID

const API_URL = process.env.REACT_APP_API_URL;

const GenerateOTPButtonRequestUser = ({ sessionId }) => {
  const [otp, setOtp] = useState('');
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);

  const generateOTP = async () => {
    try {
      const response = await axios.post(`${API_URL}/generate-otp-request-user/`, { session_id: sessionId });

      setOtp(response.data.OTP);
      setIsOtpGenerated(true);
      setMessage('OTP generated successfully!');
      setOpen(true);
    } catch (error) {
      setMessage('Error generating OTP');
      setOpen(true);
    }
  };

  const regenerateOTP = async () => {
    try {
      const response = await axios.post(`${API_URL}/generate-otp-request-user/`, { session_id: sessionId });

      setOtp(response.data.OTP);
      setMessage('OTP regenerated successfully!');
      setOpen(true);
    } catch (error) {
      setMessage('Error regenerating OTP');
      setOpen(true);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '20vh',
        backgroundColor: '#1111',
        padding: { xs: 2, sm: 4 },
      }}
    >
      <Paper
        sx={{
          backgroundColor: '#3333',
          padding: 4,
          borderRadius: 3,
          boxShadow: 4,
          width: { xs: '90%', sm: '70%', md: '50%' },
        }}
      >
        <Typography variant="h5" component="h1" sx={{ color: '#1E90FF', textAlign: 'center', marginBottom: 2, letterSpacing: 4 }}>
          OTP Generation
        </Typography>

        <Typography variant="body2" sx={{ color: '#bdc3c7', marginBottom: 2, textAlign: 'center', letterSpacing: 3 }}>
          Generate or regenerate your OTP for the session. Once generated, the OTP will be displayed below.
        </Typography>

        <TextField
          label="Generated OTP"
          variant="outlined"
          value={otp}
          sx={{ marginBottom: 2, width: '100%', letterSpacing: 3 }}
          disabled
          inputProps={{
            style: {
              color: '#ecf0f1',
              backgroundColor: '#333333',
              borderRadius: 4,
            },
          }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={isOtpGenerated ? regenerateOTP : generateOTP}
            sx={{
              width: '45%',
              fontSize: { xs: '0.875rem', sm: '1rem' },
              backgroundColor: '#1E90FF',
              letterSpacing: 3,
              '&:hover': {
                backgroundColor: '#1c73d7',
              },
            }}
          >
            {isOtpGenerated ? 'Regenerate OTP' : 'Generate OTP'}
          </Button>
        </Box>

        {/* Helper text */}
        <Typography variant="caption" sx={{ color: '#bdc3c7', textAlign: 'center', marginTop: 1, letterSpacing: 3 }}>
          {isOtpGenerated
            ? 'You can regenerate the OTP if needed.'
            : 'Click the button to generate your OTP.'}
        </Typography>
      </Paper>

      {/* Snackbar for feedback */}
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity={message.includes('Error') ? 'error' : 'success'} sx={{ width: '100%', letterSpacing: 3 }}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default GenerateOTPButtonRequestUser;
